import { gql } from '@apollo/client';

export const CANCEL_SCHEDULED_HISTORICAL_IMPORT = gql`
    mutation CancelScheduledHistoricalImport($id: ID!) {
        cancelScheduledHistoricalImport(id: $id) {
            id
            status
            cancelledAt
            cancelledBy {
                id
                firstName
                lastName
            }
        }
    }
`;
